/** @jsx jsx */
import { Fragment } from 'react';
import { QueryClientProvider } from 'react-query';
import { CookiesProvider } from 'react-cookie';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import * as Sentry from '@sentry/react';
import { jsx } from '@balance-web/core';
import { ToastProvider } from '@balance-web/toast';
import { UniversalNextLink } from '@balance-web/next-link';

import { ErrorBoundaryProvider } from '@reckon-web/error-boundary';
import { LoadGoogleTagManagerService } from '@reckon-web/google-tag-manager';
import { ReckonBalanceCore } from '@reckon-web/reckon-balance-core';

import { IdContextProvider } from '../context';
import { queryClient } from '../services/queryClient';
import { Config } from '../services/Config';
import { AuthProvider } from '../context/AuthProvider';

(async () => {
  if ('undefined' === typeof window) {
    return;
  }
  LoadGoogleTagManagerService({
    apiKey: Config.APPLICATION_GOOGLE_GTM_APIKEY,
  });
})();
Sentry.init({
  dsn: Config.APPLICATION_SENTRY_DSN,
  environment: Config.STAGE,
  release: Config.APPLICATION_VERSION,
});

export default function App({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <Fragment>
        <Head>
          <script src="polyfill.min.js" />
        </Head>
        <ReckonBalanceCore linkComponent={UniversalNextLink} themeMode="light">
          <CookiesProvider>
            <ErrorBoundaryProvider>
              <ToastProvider>
                <Head>
                  <meta
                    content="826880769594-b83j9d09fuagkonq8jibpqv03k54i57m.apps.googleusercontent.com"
                    name="google-signin-client_id"
                  ></meta>
                  {/* Google Auth */}
                  <script src="https://apis.google.com/js/platform.js"></script>
                  <script src="/public/adal.min.js"></script>
                </Head>
                <IdContextProvider>
                  <AuthProvider>
                    <Component {...pageProps} />
                  </AuthProvider>
                </IdContextProvider>
              </ToastProvider>
            </ErrorBoundaryProvider>
          </CookiesProvider>
        </ReckonBalanceCore>
      </Fragment>
    </QueryClientProvider>
  );
}
